var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    tabIndex: 0,
    "aria-label": "share the digital giveaway on linkedin",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "LinkedIn") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M2.624 1H21.37c.899 0 1.63.71 1.63 1.585v18.827c0 .876-.73 1.588-1.628 1.588H2.624C1.729 23 1 22.288 1 21.412V2.585C1 1.71 1.729 1 2.624 1m4.88 8.052H4.537v9.547h2.967zm.23-3.033a1.72 1.72 0 0 0-2.93-1.216 1.72 1.72 0 0 0 0 2.433c.323.322.76.504 1.215.505a1.72 1.72 0 0 0 1.716-1.722Zm1.628 3.033h-.004l.004-.002zm0 0v9.546h2.96v-4.724c0-1.244.237-2.45 1.779-2.45 1.519 0 1.539 1.425 1.539 2.532V18.6h2.96v-5.237c0-2.57-.554-4.548-3.553-4.548-1.447 0-2.413.791-2.809 1.542h-.04V9.052z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.77c30c2635ccf373f856cb2171d1d34c.svg";
export { ForwardRef as ReactComponent };